import Description from './Description.container';

export default Description;
